<template>
  <div class="system-log app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>操作事件</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入操作事件" v-model="table.search.event"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>操作模块</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入操作模块" v-model="table.search.module"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>操作日期</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.date" class="app-block" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange"></a-table>
  </div>
</template>

<script>
  import SystemLogService from '@/io/system_log.js';

  export default {
    name: 'SystemLog',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            event: null,
            module: null,
            date: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '操作日期',
              dataIndex: 'created_at'
            },
            {
              title: '操作人员',
              dataIndex: 'username'
            },
            {
              title: '操作模块',
              dataIndex: 'content'
            },
            {
              title: '操作事件',
              dataIndex: 'event'
            },
          ]
        }
      }
    },
    mounted () {
      this.initData();
    },
    methods: {
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          event: null,
          module: null,
          date: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return SystemLogService.listPage(
          this.table.search.event,
          this.table.search.module,
          this.table.search.date[0],
          this.table.search.date[1],
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>